<template>
  <v-btn variant="tonal" class="!px-2 min-w-14" @click="clickOnPreview">
    <v-img
      width="36"
      height="36"
      v-if="loadedPreviewEntry?.loadingState === 'success'"
      :src="loadedPreviewEntry.url"
    ></v-img>
    <v-icon v-else>mdi-image</v-icon>
    <v-dialog activator="parent">
      <template #default="{ isActive }">
        <v-card class="w-full min-h-96 min-w-96 mx-auto" :title="label.Layout" :subtitle="label.MaterialDescription">
          <template #append>
            <v-btn icon="mdi-close" @click="isActive.value = false"></v-btn>
          </template>
          <v-card-text class="w-full flex justify-center items-center">
            <div
              v-if="loadedPreviewEntry?.loadingState === 'loading' || !loadedPreviewEntry"
              class="h-full w-full flex justify-center items-center"
            >
              <v-progress-circular indeterminate :size="45"></v-progress-circular>
            </div>
            <img v-else-if="loadedPreviewEntry.loadingState === 'success'" :src="loadedPreviewEntry?.url" />
            <div v-else-if="loadedPreviewEntry?.loadingState === 'failed'" class="flex flex-col items-center">
              <h1>{{ i18n.global.t("app.printLabels.loadingPreview.error") }}</h1>
              <br />
              <v-btn @click="start()" prepend-icon="mdi-refresh">{{
                i18n.global.t("app.printLabels.loadingPreview.retry")
              }}</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>
  </v-btn>
</template>
<script setup lang="ts">
import { PrintItems } from "@/api-client/responses";
import { PropType, computed, onUnmounted } from "vue";
import { useLabelStore } from "@/store";
import { i18n } from "@/locales";

const labelStore = useLabelStore();

const props = defineProps({
  label: {
    required: true,
    type: Object as PropType<PrintItems.PrintItem>,
  },
});
const key = JSON.stringify(props.label);
const loadedPreviewEntry = computed(() => {
  return labelStore.loadedPreviews.get(key);
});

start();
async function start() {
  const foundEntry = labelStore.loadedPreviews.get(key);
  // check if already loading or finished
  if (foundEntry && (foundEntry.loadingState === "success" || foundEntry.loadingState === "loading")) return;

  // trigger load
  await labelStore.loadResourceLocationFromLabel(props.label);
}

onUnmounted(() => {
  const foundEntry = labelStore.loadedPreviews.get(key);
  if (!foundEntry) return;
  if (foundEntry.loadingState !== "success") return;
  const url = foundEntry.url;
  labelStore.loadedPreviews.delete(key);
  window.URL.revokeObjectURL(url);
});

function clickOnPreview() {
  start();
}
</script>
<style lang="scss" scoped></style>
